import { call, put, select, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { StakeType } from 'app/lib/staking/constants';

import { SWITCH_TO_TOTAL_AMOUNT, SwitchToTotalAmount } from '../actions/entries';
import {
  changeStakeTypeAmount,
  UPDATE_CHECKED_STAKE_TYPE, UpdateCheckedStakeType,
} from '../actions/stakeTypes';
import { removeExpressFreeBet } from '../actions/stakeTypes/express';
import { AccountType } from '../constants';
import { selectTotalAmountActive } from '../selectors/entries';
import { selectExpressFreeBet } from '../selectors/stakeTypes/express';
import { ExpressStakeTypeState } from '../types/stakeTypes/express';

// ---

type Actions = UpdateCheckedStakeType | SwitchToTotalAmount;

function* updateCheckedStateType(): SagaIterator {
  while (true) {
    const action: Actions = yield take([UPDATE_CHECKED_STAKE_TYPE, SWITCH_TO_TOTAL_AMOUNT]);

    const expressFreeBet: ExpressStakeTypeState['freeBet'] = yield select(selectExpressFreeBet);

    switch (action.type) {
      case UPDATE_CHECKED_STAKE_TYPE: {
        const { value } = action.payload;

        const totalAmountActive: boolean = yield select(selectTotalAmountActive);

        const isSingleStakeType = value === StakeType.SINGLE && totalAmountActive;

        if (expressFreeBet && (isSingleStakeType || value === StakeType.SYSTEM)) {
          yield call(setInitialStakeTypeAmount);
        }
        break;
      }

      case SWITCH_TO_TOTAL_AMOUNT: {
        if (expressFreeBet) {
          yield call(setInitialStakeTypeAmount);
        }
        break;
      }
    }
  }
}

function* setInitialStakeTypeAmount() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  yield put(changeStakeTypeAmount('', AccountType.MAIN_ACCOUNT));
  yield put(removeExpressFreeBet());
}

export default updateCheckedStateType;
